export type IsShowFlagsOptions = {
  contentfulLocale?: string;
  detectedCountry?: string | null;
};

/**
 * Country flags stay hidden on every locale.
 *
 * A flag next to Taiwan conflicts with the One China policy (DBP-4709).
 * Flags are omitted for all regions so Taiwan is not the only entry without one.
 */
export function isShowFlags(_options: IsShowFlagsOptions = {}): boolean {
  return false;
}
